export default __webpack_public_path__ + "static/media/noiseGrey2.03c3df15.png";